export const projectMembersSelector = state => state.project.projectMembers
export const nonProjectMembersSelector = state => state.project.nonProjectMembers

export const sceneMembersSelector = state => state.project.sceneMembers
export const nonSceneMembersSelector = state => state.project.nonSceneMembers

export const sceneVersionsSelector = state => state.project.sceneVersions